/**
 * SGKC021A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface Sgkc021aReqReferencetableShutokuinfoDto {

    /**
     * 単価表コード
     */
    tankatableCode?: string;
    /**
     * 料金算定年月
     */
    chargeCalcYm?: string;
    /**
     * 使用量上限
     */
    empamtUpperlimit?: number;
    /**
     * 早見表出力間隔コード
     */
    referencetableOutputintervalCode?: string;
}

